window.KUWAHARA = {};

import CheckDevice from './_modules/_checkDevice';
import Menu from './_modules/_menu';
import TelLink from './_modules/_telLink';
import Accordion from './_modules/_accordion';
import SmoothScroll from './_modules/_smoothScroll';
import EqHeight from './_modules/_eqHeight';

(function (window, document, $, undefined){

  KUWAHARA.device = new CheckDevice($('.js-device'));

  $(window).on('resize', (e) => {
    KUWAHARA.device.resize();
  });

  $('.js-menu-open').each((i, el) => {
    new Menu();
  });

  $('.js-tel').each((i, el) => {
    new TelLink(el);
  });

  $('.js-accordion').each((i, el) => {
    new Accordion(el);
  });

  $('.js-scroll').each((i, el) => {
    new SmoothScroll(el);
  });

  $('.js-height').each((i, el) => {
    new EqHeight(el);
  });

})(window, document, jQuery);


// WEBPACK FOOTER //
// ./js/common.js